import { RouteConfig } from 'vue-router';
const Home = () => import('./home.vue');
const Evaluation = () => import('../evaluation/evaluation.vue');
const System = () => import('../system/system.vue');
const Account = () => import('../account/account.vue');
const Patient = () => import('../patient/patient.vue');
const Manage = () => import('../manage/manage.vue');
const Assess = () => import('../assess/assess.vue');
const Statistics = () => import('../statistics/statistics.vue');
const Setting = () => import('../setting/setting.vue');
const Report = () => import('../report/report.vue');
const Knowledge = () => import('../knowledge/knowledge.vue');
import EvaluationRouterChildren from '../evaluation/evaluation.router';
import SystemRouterChildren from '../system/system.router';
import AccountRouterChildren from '../account/account.router';
import PatientRouterChildren from '../patient/patient.router';
import ManageRouterChildren from '../manage/manage.router';
import AssessRouterChildren from '../assess/assess.router';
import StatisticsRouterChildren from '../statistics/statistics.router';
import SettingRouterChildren from '../setting/setting.router';
import ReportRouterChildren from '../report/report.router';
import KnowledgeRouterChildren from '../knowledge/knowledge.router';
const routers: RouteConfig[] = [
    {
        path: 'home',
        component: Home,
    },
    {
        path: 'evaluation',
        component: Evaluation,
        children: EvaluationRouterChildren
    },
    {
        path: 'account',
        component: Account,
        children: AccountRouterChildren
    },
    {
        path: 'system',
        component: System,
        children: SystemRouterChildren
    },
    {
        path: 'patient',
        component: Patient,
        children: PatientRouterChildren
    },
    {
        path: 'manage',
        component: Manage,
        children: ManageRouterChildren
    },
    {
        path: 'assess',
        component: Assess,
        children: AssessRouterChildren
    },
    {
        path: 'statistics',
        component: Statistics,
        children: StatisticsRouterChildren
    },
    {
        path: 'setting',
        component: Setting,
        children: SettingRouterChildren
    },
    {
        path: 'report',
        component: Report,
        children: ReportRouterChildren
    },
    {
        path: 'knowledge',
        component: Knowledge,
        children: KnowledgeRouterChildren
    },
];
export default routers;

